<!--
 * @Author: your name
 * @Date: 2020-08-26 15:52:29
 * @LastEditTime: 2024-08-01 11:28:31
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares\src\components\system\UserManage.vue
-->
<template>
  <div class="user-manage">
    <subfield>
      <template slot="list">
        <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-uc>
          <template slot="up">
            <div class="c-u-left flex-b-c">
              <!-- <img
                class="icon"
                src="@/assets/images/public/public_add.png"
                @click="addUserForm"
                alt
              /> -->
              <el-button icon="el-icon-plus" size="mini" type="primary" @click="addUserForm" round>{{$t('system.NewAccounts')}}</el-button>
              <div style="margin-left:16px">
                <span>账号数量:</span>
                <span>{{ userList.length }}</span>
              </div>
            </div>
            <div class="c-u-right"></div>
          </template>
          <template slot="center">
            <el-table :data="userList" style="width: 100%" height="100%" v-loading="loading">
              <el-table-column prop="name" :label="$t('csum1')"></el-table-column>
              <el-table-column prop="realname" :label="$t('csum2')"></el-table-column>
              <el-table-column prop="role" :label="$t('csum3')"></el-table-column>
              <!-- <el-table-column prop="user_level" label="等级"></el-table-column> -->
              <el-table-column prop="priority" :label="$t('csum4')"></el-table-column>
              <el-table-column prop="remark" :label="$t('csum5')"></el-table-column>
              <el-table-column :label="$t('csum6')" width="180">
                <template slot-scope="scope">
                  <div class="operation">
                    <img class="icon" src="@/assets/images/public/public_edit.png" @click="handleEdit(scope.$index, scope.row)" alt />
                    <img class="icon" src="@/assets/images/public/public_delete.png" @click="handleDelete(scope.$index, scope.row)" alt v-show="userId !== scope.row.id" />
                    <img class="icon" :src="
                        parseInt(scope.row.isforbidden) ? switchON : switchOFF
                      " @click="userSwitch(scope.$index, scope.row)" alt v-show="userId !== scope.row.id" />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </enfold-uc>
        <form-dialog :dialogVisible="FormDialogVisible" @closeDialog="FormCloseDialog" :title="FormDialogClass" dWidth="400px">
          <div class="form-dialog">
            <el-form :model="addEditData" :rules="rules" ref="userForm" label-width="100px">
              <div class="form-item">
                <el-form-item :label="$t('csum7')" prop="group_id" v-if="addAndEditShow || !isSelf">
                  <el-select v-model="addEditData.group_id" :placeholder="$t('csum8')" style="width: 100%">
                    <el-option v-for="(item, index) in groupIdLabel" :key="index" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('csum9')" prop="role_id" v-if="addAndEditShow || !isSelf">
                  <div class="flex-b-c">
                    <el-select v-model="addEditData.role_id" :placeholder="$t('csum10')" style="width: 100%">
                      <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
                    </el-select>
                    <el-tooltip placement="right">
                      <div slot="content">
                        <span style="line-height: 24px;">
                          {{$t('csum11')}}
                          <br />
                        </span>
                        <span style="line-height: 24px;">
                          {{$t('csum12')}}
                          <br />
                        </span>
                        <span style="line-height: 24px;">{{$t('csum13')}}</span>
                      </div>
                      <i class="el-icon-question" style="font-size: 24px; color: #000; "></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('csum1')" prop="username">
                  <el-input v-model="addEditData.username" :disabled="!addAndEditShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('csum2')" prop="realname">
                  <el-input v-model="addEditData.realname" auto-complete="new-password"></el-input>
                </el-form-item>
                <el-form-item :label="$t('csum14')" prop="password" v-if="addAndEditShow">
                  <el-input v-model="addEditData.password" type="password" auto-complete="new-password"></el-input>
                </el-form-item>
                <el-form-item :label="$t('csum15')" prop="rpassword" v-if="addAndEditShow">
                  <el-input v-model="addEditData.rpassword" type="password" auto-complete="new-password"></el-input>
                </el-form-item>
                <el-form-item :label="$t('csum16')">
                  <el-input type="email" v-model="addEditData.email"></el-input>
                </el-form-item>
                <el-form-item :label="$t('csum5')">
                  <el-input v-model="addEditData.remark"></el-input>
                </el-form-item>
                <el-form-item label="用户等级" v-if="!isSelf">
                  <el-input v-model="addEditData.priority"></el-input>
                </el-form-item>
              </div>
              <el-form-item>
                <el-button @click="resetForm('userForm')" round>{{$t('csum17')}}</el-button>
                <el-button type="primary" @click="submitForm('userForm')" round>{{$t('csum18')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </form-dialog>
        <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('csum19')">
          <div class="dd-dialog">{{$t('csum20')}}</div>
        </del-dialog>
        <banned-dialog :dialogVisible="onOffDialogVisible" @closeDialog="onOffCloseDialog" :buttonName="isSwitch" :title="isSwitch[2] ? $t('csum21') : $t('csum22')">
          <div class="dd-dialog">
            请问是否要{{ isSwitch[2] ? "解封" : "封禁" }}当前或从属设备？
          </div>
        </banned-dialog>
      </template>
    </subfield>
  </div>
</template>
<script>
import subfield from '@/components/basics/Subfield'
import EnfoldUc from '@/components/basics/EnfoldUC'
import trees from '@/components/basics/Trees'
import FormDialog from '@/components/basics/FormDialog'
import DelDialog from '@/components/basics/DelDialog'
import BannedDialog from '@/components/basics/BannedDialog'
import Utils from "@/assets/scripts/Utils";
import { getChildrenIds } from "@/assets/scripts/publicFunction";
import { superDeepClone } from "@/assets/scripts//clone";

export default {
  name: "UserManage",
  data() {
    // 确认密码验证
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('csum25')))
      } else if (value !== this.addEditData.password) {
        callback(new Error(this.$t('csum26')))
      } else {
        callback()
      }
    }
    return {
      groupList: [], // 组织结构
      groupIds: sessionStorage.getItem('group_ids'), // 当前用户选择的组织结构
      userList: [],
      groupIdLabel: [],
      userIdDel: "",
      userIdSwitch: "",
      switchON: require('@/assets/images/public/public_activate.png'),
      switchOFF: require('@/assets/images/public/public_deactivate.png'),
      isSwitch: [],
      FormDialogVisible: false,
      FormDialogClass: this.$t('csum27'),
      DelDialogVisible: false,
      onOffDialogVisible: false,
      addAndEditShow: true,
      isSelf: true,
      addEditData: {},
      roleList: [],
      loading: true,
      userId: parseInt(this.$cookies.get("user_id")),
      FormData: {
        user_id: "",
        username: '',
        realname: '',
        password: '',
        rpassword: '',
        remark: '',
        role_id: '',
        group_id: parseInt(this.$cookies.get("group_id")),
        user_level: 1,
        user_pid: this.$cookies.get("user_id"),
        priority: parseInt(this.$cookies.get("priority")) + 1
      },
      rules: {
        // 表单验证
        username: [{ required: true, validator: this.checkUserName, trigger: 'blur' }],
        realname: [{ required: true, message:  this.$t('csum28'), trigger: 'blur' }],
        password: [{ required: true, message:  this.$t('csum29'), trigger: 'blur' }, {
          pattern: new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)((?=.*[~!@#$%^&*])).{12,}/),
          message: "必须12位及以上且包含字母,数字以及特殊字符"
        }],
        rpassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        role_id: [{ required: true, message: this.$t('csum31'), trigger: 'change' }],
        group_id: [{ required: true, message: this.$t('csum32'), trigger: 'change' }],
      }
    }
  },
  created() {
    // 获取组织结构分组
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
      this.groupIdLabel = this.resetSelectOptions(superDeepClone(data));
    });
    // 获取组织结构下面的用户
    this.getUserList({ group_ids: sessionStorage.getItem('group_ids') });
    // 获取角色列表
    this.getRoleList({});
    this.addEditData = this.FormData;
    if (this.$route.params.type === "addUser") {
      this.$nextTick(() => {
        setTimeout(() => {
          this.FormDialogVisible = true;
        }, 500);
      });
    }
  },
  methods: {
    getAssets(ids) {
      console.log(ids);
      this.groupIds = ids.ids;
      this.getUserList({ group_ids: this.groupIds });
    },
    getUserList(userData) {
      this.$http.post("/admin/access/userList", userData, data => {
        this.userList = data;
        this.loading = false;
      });
    },
    getRoleList(userData) {
      this.$http.post("/admin/access/roleList", userData, data => {
        this.roleList = data;
        this.FormData.role_id = this.roleList[0].id;
      });
    },
    resetSelectOptions(data, str = "", arr = []) {
      str += "\u00a0\u00a0";
      for (var i = 0; i < data.length; i++) {
        let obj = data[i];
        if (obj.child) {
          obj.name = str + obj.name;
          arr.push(data[i]);
          this.resetSelectOptions(obj.child, str, arr);
        }
      }
      return arr;
    },
    FormCloseDialog(type) {
      this.FormDialogVisible = false;
      if (type) {
        console.log(this.addForm);
      }
    },
    DelCloseDialog(isConfirm = false) {
      if (isConfirm) {
        this.$http.post("/admin/access/delUser", { user_id: this.userIdDel }, data => {
          console.log(data);
          this.getUserList({ group_ids: this.groupIds });
        });
      }
      this.DelDialogVisible = false;
    },
    onOffCloseDialog(isConfirm) {
      let isForbidden = this.isSwitch[2] ? 0 : 1;
      let forbiddenUserIds = "";
      if (isConfirm === false) {
        forbiddenUserIds = getChildrenIds(this.userList, this.userIdSwitch.id).join(",");
      } else if (isConfirm === true) {
        forbiddenUserIds = this.userIdSwitch.id
      } else {
        this.onOffDialogVisible = false;
        return;
      }
      this.$http.post("/admin/access/userForbidden", { isForbidden, userListIds: this.userListIds, forbiddenUserIds }, data => {
        this.userList = data;
      });
    },
    handleEdit(index, row) {
      this.editUserForm(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.DelDialogVisible = true;
      this.userIdDel = row.id;
    },
    userSwitch(index, row) {
      // console.log(index, row);
      this.onOffDialogVisible = true;
      this.isSwitch = !parseInt(row.isforbidden) ? ['封禁当前', '封禁从属', false] : ['解禁当前', '解禁从属', true];
      this.userIdSwitch = row;
    },
    // 添加用户
    addUserForm() {
      this.addAndEditShow = true;
      this.FormDialogClass = this.$t('csum35');
      this.addEditData = superDeepClone(this.FormData);
      // this.addEditData.user_level = parseInt(this.addEditData.user_level) + 1;
      this.FormDialogVisible = true;
    },
    // 修改修改用户
    editUserForm(index, row) {
      this.isSelf = row.id == this.$cookies.get("user_id");
      this.addAndEditShow = false;
      this.FormDialogClass = this.$t('csum36');
      this.addEditData = superDeepClone(this.FormData);
      this.addEditData.realname = row.realname;
      this.addEditData.username = row.name;
      this.addEditData.user_id = row.id;
      this.addEditData.role_id = row.role_id;
      this.addEditData.group_id = row.group_id;
      this.addEditData.user_level = row.user_level;
      this.addEditData.priority = row.priority;
      this.FormDialogVisible = true;
    },
    submitForm(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid && this.addAndEditShow) {
          // 新增用户
          this.$http.post("/admin/access/addUser", this.addEditData, data => {
            console.log(data);
            this.getUserList({ group_ids: sessionStorage.getItem('group_ids') });
          });
          this.FormDialogVisible = false;
        } else if (valid && !this.addAndEditShow) {
          // 编辑用户
          this.$http.post("/admin/access/editUser", this.addEditData, data => {
            console.log(data);
            this.getUserList({ group_ids: sessionStorage.getItem('group_ids') });
          });
          this.FormDialogVisible = false;
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(userForm) {
      this.FormDialogVisible = false;
      this.$refs[userForm].resetFields();
    },
    async accountVerification() {
      let state = false;
      this.addAndEditShow && await this.$http.post("/admin/access/validateUser", { username: this.addEditData.username }, data => {
        console.log(data);
        if (data == 999999997) {
          state = true;
        }
      });
      return state;
    },
    // 账户验证
    async checkUserName(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('csum37')));
      }
      let regexp = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/;
      if (!regexp.test(value)) {
        callback(new Error(this.$t('csum38')));
      }
      if (value.length < 2 || value.length > 20) {
        callback(new Error(this.$t('csum39')));
      }
      if (await this.accountVerification()) {
        callback(new Error(this.$t('csum40')));
      }
      callback();
    }
  },
  computed: {
    groupIdList() {
      let self = this;
      let data = Utils.MSDataTransfer.treeToArray(
        self.groupList,
        null,
        null,
        self.defaultExpandAll
      );
      return data;
    },
    userListIds() {
      return this.userList.map(res => res.id).join(",");
    }
  },
  components: {
    subfield,
    trees,
    FormDialog,
    DelDialog,
    BannedDialog,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.user-manage {
  width: 100%;
  height: 100%;
  .msg-dialog {
    /deep/ .md-content {
      height: calc(100vh - 300px);
      max-height: 500px;
      .form-dialog {
        padding-right: 0px;
        .form-item {
          height: calc(100vh - 360px);
          max-height: calc(500px - 60px);
          overflow-y: auto;
          padding-bottom: 22px;
          padding-right: 30px;
        }
      }
    }
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
.icon {
  width: 30px;
}
.organizational {
  height: 262px;
  padding: 0 6px;
  background-color: #fff;
  .organizational-select {
    height: 262px;
    overflow-y: scroll;
  }
}
</style>
